import React, { useEffect, useMemo, useState } from 'react'
import logo from '../../../assets/website/images/logo-white.png';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CMSOptions } from '../services/website.services'
import { FOOTER_LOCATION, MENU_LOCATION } from '../../../utils/Constants';

const WebsiteFooter = () => {

  const [getGlobalData, setGlobalData] = useState({});
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const myGlobalData = useSelector((state) => state.globalData?.data);
  const [refreshOptionsAPI, setRefreshOptionsAPI] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (myGlobalData) {
      const settingsData = JSON.parse(myGlobalData);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  const handelScrollTop = () => {
    document.querySelector("html, body").scrollTop = 0;
  }

  useEffect(() => {
    CMSOptions(MENU_LOCATION.menu_of_page_footer).then((response) => {
      setDynamicOptions(response?.data);
    }).catch((error) => {
      console.log("error of terms&conditions", error);
    });
  }, [refreshOptionsAPI]);

  // useMemo(()=>{
  //   document.addEventListener('language_change',function(){
  //     setRefreshOptionsAPI(!refreshOptionsAPI);
  //   })
  // });


  return (
    <div className="footer-marketing">
      <footer>
        <div className='footer-main'>
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="footer-logo">
                  <a href="#">
                    <img src={logo} alt="Pouring coffee" className="img-fluid" onClick={handelScrollTop} />
                  </a>
                  <p>{t('website.footer.web_footer_text')}</p>
                </div>
              </div>
              <div className="col-md-2 ms-auto">
                <div className="footer-menu-link">
                  <h4>{t('website.footer.web_footer_company')}</h4>
                  <ul className='link-menu'>
                    <li>
                      {/* <a href="#">{t("website.footer.web_footer_link_our_story")}</a> */}
                      <Link onClick={handelScrollTop} to={`/`}>{t("website.footer.web_footer_link_our_story")}</Link>
                    </li>
                    <li>
                      {/* <a href="#">{t("website.footer.web_footer_link_about_us")}</a> */}
                      <Link onClick={handelScrollTop} to={`/about-us`}>{t("website.footer.web_footer_link_about_us")}</Link>
                    </li>
                    <li>
                      <Link onClick={handelScrollTop} to={`/contact-us`}>{t("website.footer.web_footer_link_contact_us")}</Link>
                    </li>
                    {
                      dynamicOptions
                        ?.filter(item => item.footer_location === FOOTER_LOCATION.company_location_of_page_footer)
                        ?.map((item, i) => {
                          return (
                            <li key={i}>
                              <Link onClick={handelScrollTop} to={`/org-info/${item?.slug}`}>{item?.title}</Link>
                            </li>
                          )
                        })
                    }
                  </ul>
                </div>
              </div>
              <div className="col-md-2">
                <div className="footer-menu-link">
                  <h4>Legal</h4>
                  <ul className='link-menu'>
                    {/* <li>
                      <a href='#'>{t('website.footer.web_footer_privacy_policy')} </a>
                    </li> */}
                    {/* <li>
                   <Link to={'#'}>{t('website.footer.web_footer_terms_condition')}</Link>
                 </li> */}
                    {/* <li>
                      <a href='#'>{t('website.footer.web_footer_terms_condition')} </a>
                    </li> */}
                    <li>
                      <Link to={`/faq`} onClick={handelScrollTop}>{t('website.footer.web_footer_support')} </Link>
                    </li>
                    {
                      dynamicOptions
                        ?.filter(item => item.footer_location === FOOTER_LOCATION.legal_location_of_page_footer)
                        ?.map((item, i) => {
                          return (
                            <li key={i}>
                              <Link onClick={handelScrollTop} to={`/org-info/${item?.slug}`}>{item?.title}</Link>
                            </li>
                          )
                        })
                    }
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="footer-menu-link">
                  <h4>{t('website.footer.web_footer_contact')}</h4>
                  {getGlobalData?.social_media_details ?
                    <>
                      <ul className="social-icon">
                        {getGlobalData?.social_media_details?.map((item, index) => (
                          <li key={index}>
                            <a href={item?.link} title={item?.title} target="_blank" rel="noreferrer" dangerouslySetInnerHTML={{ __html: (item?.icon) }}>
                            </a>
                          </li>
                        ))
                        }
                      </ul>
                    </> : <></>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='footer-last'>
          {getGlobalData?.copy_right_text}
        </div>
      </footer>
    </div>
  );
}

export default WebsiteFooter;